import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import { TEXT_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';
import { OVERVIEW_TEXT_TYPE_ID } from '../../../mgmt/communities/components/legalAndTexts/constants';

export default lookupService(({ tag, language }) => ({
  resource: TEXT_RESOURCE,
  url: apiRoutes.text(tag, OVERVIEW_TEXT_TYPE_ID, language),
}));
